export enum LOYALTY_TRANSACTION_TYPES {
  REWARD = 'reward',
  ADJUSTMENT = 'adjustment'
}
